export default "__VITE_PUBLIC_ASSET__e845d05c__"